module.exports = __webpack_public_path__ + "img/index6.d481c8d5.png";